import db from './indexDB'

export default {
    async clearHolidays(){
        await db.publicHolidays.clear();
    },
    async putHolidays(holidays) {
        await db.publicHolidays.bulkPut(holidays);
    },
    async getHolidays() {
        await db.publicHolidays.ToArray();
    },
}